import '../globals.css'

import React from 'react'
import ReactDOM from 'react-dom/client'

import { initSentry } from '../sentry.config.ts'
import App from './App.tsx'

initSentry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
